<template>
	<AtomCard
		:class="[
			'rounded-lg border-4 border-purple-50 overflow-hidden flex flex-col justify-between gap-8 min-w-[28rem] shadow-purple-200',
			{
				'pb-12': !bottomBanner,
			},
		]"
	>
		<div class="bg-gradient-to-br from-purple-300 to-green-400  -skew-y-6 pt-20 pb-10 mb-10 -mt-8 border-b-8 border-double border-white">
			<div class="skew-y-6 px-10">
				<div class="flex flex-col gap-6">
					<div class="flex flex-col-reverse gap-2">
						<AtomTitle
							tag="h2"
							class="uppercase text-purple-900"
							size="xl"
						>
							{{ title }}
						</AtomTitle>
						<div v-if="label">
							<AtomLabel
								variant="white"
								size="sm"
							>
								{{ label }}
							</AtomLabel>
						</div>
					</div>
				</div>
			</div>
			<div class="px-10 grow skew-y-6 mt-6">
				<MoleculeIconList
					class="flex flex-col gap-4"
					:items="usps"
				/>
			</div>
		</div>
		<div class="flex flex-col gap-8">
			<div class="flex flex-col gap-2 px-10">
				<p
					v-if="price"
					class="inline-flex flex-col gap-1 text-left"
				>
					<span
						v-if="price.prefix"
						class="text-paragraph-size-sm leading-8 text-gray-700"
					>
						{{ price.prefix }}
					</span>
					<span class="flex gap-4 items-center">
						<span
							class="text-title-size-xl font-bold text-purple-900"
						>
							<AtomPrice :value="price.value" />
						</span>
						<span
							v-if="price.subject"
							class="text-paragraph-size-sm leading-8 text-gray-700 text-nowrap"
						>
							{{ price.subject }}
						</span>
					</span>
				</p>
			</div>
			<div class="px-10 flex flex-col gap-4">
				<AtomButton
					v-if="secondaryButtonText && secondaryButtonTo"
					:variant="ButtonVariant.DarkBorder"
					:text="secondaryButtonText"
					size="md"
					:to="secondaryButtonTo"
				/>
				<AtomButton
					:variant="ButtonVariant.Green"
					:text="buttonText"
					class="w-full"
					size="md"
					:to="to"
				/>
			</div>
		</div>
		<div
			v-if="bottomBanner"
			class="bg-gradient-to-tr from-purple-700 to-purple-300 px-8 py-6 flex flex-col gap-4 rounded-b"
		>
			<p
				class="text-center text-white text-paragraph-size-sm md:text-paragraph-size-md"
			>
				{{ bottomBanner.title }}
			</p>
			<AtomButton
				:variant="ButtonVariant.Transparent"
				:text="bottomBanner.buttonText"
				class="w-full text-white border-white border-2"
				size="md"
				:to="bottomBanner.to"
				@click="emit('clickBottomBanner')"
			/>
		</div>
	</AtomCard>
</template>

<script lang="ts" setup>
import { ButtonVariant } from '#base/core/enums/ButtonVariantEnum';
import { subscriptionGroupSchema } from '#fit/helpers/schemaHelpers';
import type { PriceType } from '#base/core/types/PriceType';
import type { UrlType } from '#base/core/types/UrlType';

const props = defineProps<{
	title: string;
	label?: string;
	price?: PriceType;
	usps: string[];
	buttonText: string;
	to: UrlType;
	secondaryButtonText?: string;
	secondaryButtonTo?: UrlType;
	bottomBanner?: {
		title: string;
		buttonText: string;
		to?: UrlType;
	};
}>();

const emit = defineEmits(['clickBottomBanner']);

useHead({
	script: [
		props.price
			? subscriptionGroupSchema(
					props.title,
					props.label ?? '',
					props.to.url,
					props.price,
				)
			: undefined,
	],
});
</script>
